import moment from 'moment-mini'

export class Organization {
  id: number
  externalKey: string
  type: string
  isActive: string
  parentOrganisationId: number
  isChildOrganization: boolean
  description: string
  additionalDescription?: string
  phone: string
  email: string
  commercialCode?: string
  website?: string
  organisationCode?: string
  organisationSecondaryCode: string
  autoApprovalDays?: number
  requiresRegistrationApproval?: boolean
  requiredSubscriptions?: number[]
  tertiaryCode?: string
  quaternaryCode?: string
  quintaryCode?: string
  addresses?: Address
  updatedAt?: moment.Moment
  siteId?: number
  category?: string | number
  abbreviation?: string

  /// relations
  members: any[]
  userRoles: any[]
}
export class Address {
  id?: number
  externalKey?: string
  zipCode?: string
  street?: string
  streetNumber?: string
  postbox?: string
  city?: string
  salutation?: string
  iban?: any
  bic?: any
  creditorNumber?: any
  country?: string
  municipality?: any
  organizationId?: string
  memberId?: any
  email?: string
  siteId?: any
}
